import { useState } from 'react'
import { Container, Grid, TextField, Box } from '@mui/material'
import Drawer from 'components/drawer/detail'
import Loading from 'components/loading/loading'
import type { DetailStateProps } from 'modules/types'
import { useGetPopUpBannerDetailQuery } from 'store/popUpBanner'
import BackdropImage from 'components/backdropImage/backdropImage'
import DetailStyle from './style'

const Detail = ({ open, id, onClose }: DetailStateProps & { id: number }) => {
  if (!open) return <Drawer open={open} onClose={onClose} />

  const { data, isLoading, isFetching } = useGetPopUpBannerDetailQuery(id)

  const [previewBackdrop, setPreviewBackdrop] = useState<boolean>(false)

  const campaignName = (data && data.campaignName) || '-'
  const periodStart = (data && data.periodStartString) || '-'
  const periodEnd = (data && data.periodEndString) || '-'
  const bannerType = (data && data.bannerType) || '-'
  const title = (data && data.title) || '-'
  const body = (data && data.body) || '-'
  const ctaDescription = (data && data.ctaDescription) || '-'
  const ctaUrl = (data && data.ctaUrl) || '-'
  const segmentationType = (data && data.segmentationType) || '-'
  const segmentationValue = (data && data.segmentationValue) || '-'
  const bannerUrl = (data && data.bannerUrl) || '-'
  const status = (data && data.status) || '-'
  const viewCount = (data && data.viewCount) || 0
  const clickCount = (data && data.clickCount) || 0
  const dismissCount = (data && data.dismissCount) || 0

  const gridDataLabel = [
    'Campaign Name',
    'Period Start',
    'Period End',
    'BannerType',
    'Title',
    'Body',
    'CTA Description',
    'CTA URL',
    'Segmentation Type',
    'Segmentation Value',
    'Banner',
    'Status',
    'View Count',
    'Click Count',
    'Dismiss Count'
  ]
  const gridDataValue = [
    campaignName,
    periodStart,
    periodEnd,
    bannerType,
    title,
    body,
    ctaDescription,
    ctaUrl,
    segmentationType,
    segmentationValue,
    bannerUrl,
    status,
    viewCount,
    clickCount,
    dismissCount
  ]

  return (
    <Drawer open={open} title='Pop Up Banner Detail' onClose={onClose}>
      <Container {...DetailStyle.Container}>
        {(isLoading || isFetching) && !data && <Loading />}
        {data && (
          <Grid container spacing={2}>
            {gridDataValue.map((item, index) => {
              // Ambil label dan pastikan casing-nya cocok
              const label = gridDataLabel[index]
              const isImageField = label === 'Banner' && item !== '-' // Sesuaikan label yang benar di data Anda

              return (
                <Grid key={index} item xs={12}>
                  {/* --- LOGIKA CONDITIONAL RENDERING --- */}
                  {isImageField ? (
                    // JIKA TRUE: Render Komponen Gambar
                    // <BannerDisplay src={item} label={label} />
                    <Box>
                      <BackdropImage
                        open={previewBackdrop}
                        onOpen={() => setPreviewBackdrop(true)}
                        onClose={() => setPreviewBackdrop(false)}
                      >
                        <img
                          src={item as string}
                          alt=''
                          style={{ height: '300px', width: '505px', objectFit: 'contain' }}
                        />
                      </BackdropImage>
                    </Box>
                  ) : (
                    // JIKA FALSE: Render TextField (Default)
                    <TextField
                      variant='outlined'
                      label={label}
                      value={item}
                      inputProps={{ readOnly: true }}
                      InputLabelProps={{
                        shrink: true
                      }}
                      fullWidth
                    />
                  )}
                </Grid>
              )
            })}
          </Grid>
        )}
      </Container>
    </Drawer>
  )
}

export default Detail
